export const UPDATE_PHONE_NUMBER_STEP_FLOW_NAME = 'update-phone-number';

export enum UpdatePhoneNumberStep {
  EnterPhone = 'EnterPhone',
  VerifyCode = 'VerifyCode',
}
